module.exports = __webpack_public_path__ + "static/media/estore.afc2308c.svg";